import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  text-align: left !important;
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: pointer;
  clear: both;
  padding: 5px 10px 5px 5px;
  color: #000;
  :hover {
    border-color: #000;
  }
  > svg {
    vertical-align: middle;
    float: left;
    font-size: 19px;
    margin-right: 5px;
  }
  > span {
    display: flex;
    float: left;
    font-family: Geomanist;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    letter-spacing: -0.4px;

    @media (max-width: 900px) {
      font-size: 18px;
      width: 250px;
    }
    @media (max-width: 360px) {
      display: flex;
      width: 230px;
      flex-direction: row;
    }
    @media (max-width: 320px) {
      display: flex;
      width: 195px;
      flex-direction: row;
    }
  }
  > a {
    display: flex;
    text-decoration: none !important;
    color: black !important;
  }
  > .add-menu-item {
    vertical-align: middle;
  }
`;

function JoinedGroup(props) {
  return (
    <Container onClick={props.onClick}>
      <span>{props.children}</span>
    </Container>
  );
}

export default JoinedGroup;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/JoinedGroup/index.jsx